import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const useLocalAnonymousId = () => {
  const router = useRouter();
  const [alid, setAlid] = useState();

  useEffect(() => {
    let id;
    try {
      if (global.window) {
        if (!router?.isFallback && global?.analytics?.user) {
          id = global.analytics.user().anonymousId();
        } else if (global.localStorage) {
          id = global.localStorage.getItem('ga-alid');
          if (!id) {
            id = uuidv4();
            global.localStorage.setItem('ga-alid', id);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
    setAlid(id || 'Unknown');
  }, [router?.isFallback]);
  return alid;
};

export const useSessionAnonymousId = () => {
  const [asid, setAsid] = useState();

  useEffect(() => {
    let id;
    try {
      if (global.window && global.sessionStorage) {
        id = global.sessionStorage.getItem('ga-asid');
        if (!id) {
          id = uuidv4();
          global.sessionStorage.setItem('ga-asid', id);
        }
      }
    } catch (error) {
      console.error(error);
    }
    setAsid(id || 'Unknown');
  }, []);

  return asid;
};
